// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__3B7Rb","loaderWrapper":"table_loaderWrapper__2tlz0"};